export default {
  siteHost: 'lily-plant.com',
  shopHost: 'pay.lily-plant.com',
  // offerHash: {
  //   onboarding: "q81gghszi29dirot",
  //   try: "9znewwm7rntjropo",
  // },
  appKey: 'd3el6mqxydspts295vamktwapcyhb8h5',
  // googleOptimizeId: "OPT-KQ6N6BX",
  // hotjarId: "2663207",
  amplitudeKey: {
    prod: 'f86023041d834d1eff6d011d1b15bf62',
    dev: '5b671a043ea1315c0bb892f1ac3ca02b',
  },
  // fbPixel: {
  //   onboarding: {
  //     prod: "659340291713591",
  //     dev: "",
  //   },
  //   try: {
  //     prod: "1341320299599532",
  //     dev: "",
  //   },
  // },
  // gaId: {
  //   onboarding: {
  //     prod: "UA-187631694-2",
  //     dev: "",
  //   },
  //   try: {
  //     prod: "UA-187631694-6",
  //     dev: "",
  //   },
  // },
  // tiktokPixelId: {
  //   prod: "C5R6R3923A9UL0EA5US0",
  //   dev: "",
  // },
};
